module.exports = __webpack_public_path__ + "static/media/project-BI.f385ae44.jpg";